import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@unmapped/core/hooks';
import { decorateName } from '@unmapped/core/utils';
import useComponentOverride from "../../hooks/useComponentOverride.js";
import { useStyleOverride } from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
export var FilterFieldset = decorateName(observer(_ref => {
  var {
    filters
  } = _ref;
  var [FilterField] = useComponentOverride('layouts/FilterField');
  var styles = useStyleOverride('layouts/FilterFieldset', baseStyles);
  var store = useStore();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.FilterFieldset
  }, filters.map((_ref2, i) => {
    var [name, filterComponent, filterLabel = name] = _ref2;
    return name in store.filterMap && store.filterMap[name].visible ? /*#__PURE__*/React.createElement(FilterField, {
      label: filterLabel,
      filterComponent: filterComponent,
      key: i
    }) : null;
  }));
}), 'FilterFieldset');
export default FilterFieldset;
//# sourceMappingURL=index.js.map